import css from 'styles/footer.module.css'
import { polygonLogo, opensea, discord } from 'assets'
import {
  blockExplorerUrl,
  openseaHref,
  discordHref,
  contractAddress,
} from 'utils'

export default function Footer() {
  return (
    <div className={`${css.container} mt pd`}>
      <div className={css.socials}>
        <a
          className="svg"
          href={`${blockExplorerUrl}address/${contractAddress}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={polygonLogo} width={16} height={16} alt="polygon logo" />
        </a>
        <a
          className="svg"
          href={openseaHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={opensea} width={16} height={16} alt="opensea logo" />
        </a>
        <a
          className="svg"
          href={discordHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={discord} width={16} height={16} alt="discord logo" />
        </a>
      </div>
      <div className={css.copyright}>
        <p>© 2022 Maups</p>
      </div>
    </div>
  )
}
